// Homepage portfolio section data — extracted from ProjectsSection.tsx so the
// component file stays focused on presentation. No business logic lives here.

export interface FeaturedProject {
  id: string;
  position: string;
  title: string;
  category:
    | "Retail & Fashion"
    | "F&B"
    | "Jewellery & Watches"
    | "Banking & Offices"
    | "Malls & Airports";
  location: string;
  area: string;
  year: string;
  image: string;
  description: string;
  highlights: string[];
}

export interface CategoryProject extends FeaturedProject {}

export const FEATURED_PROJECT: FeaturedProject = {
  id: "illy-cafe-featured",
  position: "02",
  title: "illy Café - City Centre Bahrain",
  category: "F&B",
  location: "City Centre Bahrain, Manama",
  area: "310 sq.m",
  year: "2023",
  image:
    "https://vibe.filesafe.space/1790273207865208150/attachments/419f1f52-9f5f-4a69-8927-8dfd6ff7047d.webp",
  description:
    "When illy Café searched for a local turnkey partner capable of meeting global Italian design specifications, Abacus delivered an extraordinary space. Featuring in-house manufactured brass details, handcrafted coffee counter joinery, and custom acoustic ceiling elements.",
  highlights: [
    "In-house manufactured brass & timber coffee counter",
    "Complete food-grade kitchen & MEP installation",
    "Client requested 3 layout revisions before approving the flawless final build",
  ],
};

export const CATEGORY_PROJECTS: CategoryProject[] = [
  {
    id: "maxmara",
    position: "01",
    title: "MaxMara - Marassi Galleria",
    category: "Retail & Fashion",
    location: "Marassi Galleria Mall, Bahrain",
    area: "380 sq.m",
    year: "2023",
    image:
      "https://vibe.filesafe.space/1790273207865208150/attachments/33d62c95-fa1c-4309-9b24-41af40d3d68b.webp",
    description:
      "Bespoke high-end fashion boutique fit-out featuring custom Italian veneers, architectural display joinery, and precision lighting design.",
    highlights: [
      "Custom architectural display fixtures",
      "Full turnkey interior contracting",
      "Strict mall compliance & zero-delay handover",
    ],
  },
  {
    id: "malabar-gold",
    position: "02",
    title: "Malabar Gold & Diamonds Showroom",
    category: "Jewellery & Watches",
    location: "Gold Souq, Manama & Mall Locations",
    area: "420 sq.m",
    year: "2024",
    image:
      "https://vibe.filesafe.space/1790273207865208150/attachments/08bfe76d-c1d1-4488-add2-50c88db33a6e.webp",
    description:
      "High-security luxury jewellery showroom with custom glass display counters, anti-reflective lighting, and reinforced security vaults.",
    highlights: [
      "High-security vault & glass counter fit-out",
      "Bespoke LED luminaire lighting scheme",
      "Custom CNC carved wood & metal panels",
    ],
  },
  {
    id: "al-salam-bank",
    position: "03",
    title: "Al Salam Bank Al Raya Mall Branch",
    category: "Banking & Offices",
    location: "Al Raya Mall at Riffa",
    area: "1,150 sq.m",
    year: "2024",
    image:
      "https://vibe.filesafe.space/1790273207865208150/attachments/b4171eb5-e0bd-4291-921e-5508a0fae2e8.webp",
    description:
      "Full corporate bank headquarters and retail banking hall with executive boardroom suites, acoustic partition walls, and smart automation.",
    highlights: [
      "Triple ISO-certified acoustic paneling",
      "Automated smart lighting & MEP integration",
      "Phased zero-downtime execution",
    ],
  },
];

export interface ClientLogo {
  name: string;
  image?: string;
}

const CDN = "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media";

// NOTE: Logos 4, 15, 16, 17, 19, 22, 25, 30, 31, 32, 36, 40, 48 and 59 were
// removed because their source assets were deleted from the CDN (HTTP 404),
// which left empty cards showing fallback "Logo N" text instead of an image.
export const CLIENT_LOGOS: ClientLogo[] = [
  { name: "Logo 1", image: `${CDN}/6a78903403343f290ff68f18.png` },
  { name: "Logo 2", image: `${CDN}/6a7890348880872019c0dbb1.png` },
  { name: "Logo 3", image: `${CDN}/6a7890349994d35aa06d27ab.png` },
  { name: "Logo 5", image: `${CDN}/6a7890349994d35aa06d27b0.png` },
  { name: "Logo 6", image: `${CDN}/6a7890349994d35aa06d27a6.png` },
  { name: "Logo 7", image: `${CDN}/6a7890368880872019c0e62c.png` },
  { name: "Logo 8", image: `${CDN}/6a78903603343f290ff68f32.png` },
  { name: "Logo 9", image: `${CDN}/6a7890379a9c7792eadbb73c.png` },
  { name: "Logo 10", image: `${CDN}/6a78903703343f290ff68f71.png` },
  { name: "Logo 11", image: `${CDN}/6a7890378880872019c0e703.png` },
  { name: "Logo 12", image: `${CDN}/6a7890379994d35aa06d27dc.png` },
  { name: "Logo 13", image: `${CDN}/6a7890399994d35aa06d27fe.png` },
  { name: "Logo 14", image: `${CDN}/6a78903a03343f290ff69b69.png` },
  { name: "Logo 18", image: `${CDN}/6a78903b9a9c7792eadbbb71.jpeg` },
  { name: "Logo 20", image: `${CDN}/6a78903b9a9c7792eadbbb83.png` },
  { name: "Logo 21", image: `${CDN}/6a78903c03343f290ff6a401.png` },
  { name: "Logo 23", image: `${CDN}/6a78903c03343f290ff6a5bf.jpeg` },
  { name: "Logo 24", image: `${CDN}/6a78903c9a9c7792eadbbba1.jpeg` },
  { name: "Logo 26", image: `${CDN}/6a78903e9994d35aa06d2868.png` },
  { name: "Logo 27", image: `${CDN}/6a78903f8880872019c0ff0d.png` },
  { name: "Logo 28", image: `${CDN}/6a78903e9994d35aa06d286e.png` },
  { name: "Logo 29", image: `${CDN}/6a78903d9a9c7792eadbbbc3.jpg` },
  { name: "Logo 33", image: `${CDN}/6a78903f03343f290ff6b28b.jpeg` },
  { name: "Logo 34", image: `${CDN}/6a78903f9994d35aa06d2ec5.png` },
  { name: "Logo 35", image: `${CDN}/6a7890409994d35aa06d304f.png` },
  { name: "Logo 37", image: `${CDN}/6a7890409994d35aa06d3211.jpeg` },
  { name: "Logo 38", image: `${CDN}/6a78904003343f290ff6b797.png` },
  { name: "Logo 39", image: `${CDN}/6a7890419a9c7792eadbbc5d.png` },
  { name: "Logo 41", image: `${CDN}/6a7890418880872019c0ff87.png` },
  { name: "Logo 42", image: `${CDN}/6a7890429a9c7792eadbbc77.png` },
  { name: "Logo 43", image: `${CDN}/6a7890428880872019c0ffc5.png` },
  { name: "Logo 44", image: `${CDN}/6a7890429a9c7792eadbbcbf.png` },
  { name: "Logo 45", image: `${CDN}/6a7890439994d35aa06d3fd1.png` },
  { name: "Logo 46", image: `${CDN}/6a78904303343f290ff6bf4c.png` },
  { name: "Logo 47", image: `${CDN}/6a7890438880872019c0ffd9.png` },
  { name: "Logo 49", image: `${CDN}/6a78904403343f290ff6bf72.png` },
  { name: "Logo 50", image: `${CDN}/6a7890449994d35aa06d40d0.png` },
  { name: "Logo 51", image: `${CDN}/6a7890449994d35aa06d40ee.png` },
  { name: "Logo 52", image: `${CDN}/6a7890459a9c7792eadbbd0d.png` },
  { name: "Logo 53", image: `${CDN}/6a7890459a9c7792eadbbd1b.png` },
  { name: "Logo 54", image: `${CDN}/6a78904503343f290ff6bfa4.png` },
  { name: "Logo 55", image: `${CDN}/6a7890468880872019c10029.png` },
  { name: "Logo 56", image: `${CDN}/6a7890468880872019c10033.png` },
  { name: "Logo 57", image: `${CDN}/6a7890469a9c7792eadbbd49.png` },
  { name: "Logo 58", image: `${CDN}/6a7890469994d35aa06d410c.png` },
  { name: "Logo 60", image: `${CDN}/6a78904703343f290ff6bfca.png` },
  { name: "Logo 61", image: `${CDN}/6a7890479994d35aa06d412e.png` },
  { name: "Logo 62", image: `${CDN}/6a78904703343f290ff6bfd8.png` },
  { name: "Logo 63", image: `${CDN}/6a78904703343f290ff6bfde.png` },
  { name: "Logo 64", image: `${CDN}/6a7890489994d35aa06d413c.jpeg` },
  { name: "Logo 65", image: `${CDN}/6a7890488880872019c10063.png` },
  { name: "Logo 66", image: `${CDN}/6a78904903343f290ff6bffe.png` },
  { name: "Logo 67", image: `${CDN}/6a78904903343f290ff6bff8.png` },
  {
    name: "Logo 68",
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/ae4e63eb-800c-411e-b714-292b569eb671.png",
  },
];
